const reducers = {
  setCurrentRouteKey: (state, action) => {
    state.currentRouteKey = action.payload
  },
  setUser: (state, action) => {
    state.user = action.payload
  },
  setSession: (state, action) => {
    state.session = action.payload
  },
  setLayoutType: (state, action) => {
    state.layoutType = action.payload
  },
  setProductCols: (state, action) => {
    state.productCols = action.payload
  },
  setInIframe: (state, action) => {
    state.inIframe = action.payload
  },
  setPreviousLayoutType: (state, action) => {
    state.previousLayoutType = action.payload
  },
  setSecure: (state, action) => {
    state.secure = action.payload
  },
  setConfigs: (state, action) => {
    state.configs = {...action.payload, general: {...action.payload.general, ...(action.payload.general.engraving === undefined ? {engraving: state.configs.general.engraving}: {}), }}
  },
  setInSecure: (state) => {
    state.secure = false
    state.token = ''
  },
  setDynamicStyles: (state, action) => {
    state.dynamicStyles = action.payload
  },
  setEnv: (state, action) => {
    state.env = action.payload
  },
  setLiquidToken: (state, action) => {
    state.liquidToken = action.payload
  },
  setElement: (state, action) => {
    state.element = action.payload
  },
  setLoading: (state, action) => {
    state.loading = action.payload
  },
  setView: (state, action) => {
    state.view = action.payload
  },
  setBg: (state, action) => {
    state.bg = action.payload
  }
}

export default reducers

